import {
  ITEM_STATE_DELETED,
  ITEM_STATE_TO_BAG_COMPLETE
} from "../../constants";

export default ({ itemState }) =>
  itemState !== ITEM_STATE_DELETED && itemState !== ITEM_STATE_TO_BAG_COMPLETE;
